export default "__VITE_ASSET__ca631ca3__"